import Vue from 'vue'
import VueLazyload from 'vue-lazyload'
import App from './App.vue'
import constant from './common/constant';
import commonFn from './common/global';
import util from './common/util';// 工具类
import md5 from 'js-md5';
import router from './router'
import axios from 'axios';
import apiConfig from '../config/api.config'
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import { messages } from './components/common/i18n';
import treeTransfer from 'el-tree-transfer';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import '../static/css/theme-green/index.css';       // 浅绿色主题
import './assets/css/main.css';
import './components/common/directives';
import "babel-polyfill";
import './assets/icon/iconfont.css';       // 图标样式

// 引入video.js 
import Videojs from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Videojs

// 引入时间转换插件
import moment from 'moment'
Vue.prototype.$moment = moment;

// 打印文件
import Print from 'vue-print-nb'
Vue.use(Print);

// 导出文件公共方法
import { exportFile } from '@/common/request'
Vue.prototype.$exportFile = exportFile

// 使用懒加载
Vue.use(VueLazyload)

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.prototype.$axios = axios;
axios.defaults.baseURL = apiConfig.baseUrl;
axios.defaults.withCredentials = false;
axios.interceptors.request.use(
    config => {
        config.headers.Authorization = 'Bearer '+sessionStorage.getItem('token');
        return config
    },
    error => {
        return Promise.reject(error)
    }
);


Vue.prototype.$commonFn = commonFn;
Vue.prototype.$constant = constant;
Vue.prototype.$util = util;
Vue.prototype.$md5 = md5;

Vue.config.productionTip = false
Vue.use(VueI18n);
Vue.use(ElementUI, {
    size: 'small'
});

const i18n = new VueI18n({
    locale: 'zh',
    messages
})

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    const role = localStorage.getItem('ms_username');
    // console.log("token:"+!sessionStorage.getItem('token'));
    // console.log("path："+to.path);
    if(!sessionStorage.getItem('token') && to.path !== '/login'){
        next('/login');
    } else if (to.meta.permission) {
        // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
        role === 'admin' ? next() : next('/403');
    } else {
        // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
        if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
            Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
                confirmButtonText: '确定'
            });
        } else {
            next();
        }
    }
})


new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js